import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
// import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Close from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';
import { Document, Page, pdfjs } from 'react-pdf';
import moment from 'moment';

import {
  Dialog,
  FormControl,
  Select,
  InputLabel,
  TextField,
  Checkbox,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Grid,
} from '@material-ui/core';
import {
  fetchProviders,
  trackPatient,
  fetchCTrackingDetails,
  updateTrackPatient,
  fetchTrackAttachments,
} from '../../../services/api';
import './tracking.css';
import PDFSingleViewer from '../../../components/PDFSingleViewer';
import ImgSingleViewer from '../../../components/ImgSingleViewer';
import {
  makeS3BlobsRenderable,
  fileSelectHandler,
} from '../../../util/fileHandling';
import NoticeDialog from '../../../components/DialogModals/NoticeDialog';
import MobileDetect from 'mobile-detect';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { addDays } from 'date-fns';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${
  pdfjs.version
}/pdf.worker.js`;
const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};
function PatientCreateTrackModal(props) {
  const {
    note = {},
    closeDialog,
    open,
    trackingEdit,
    patientId,
    classes: {
      appBar,
      title,
      selectInput,
      formControl,
      customLabel,
      wholeSection,
      customText,
      customSelect,
      customTextArea,
      customBtn,
      customFormGroup,
      previewImg,
      customDatePickerOne,
      customFileUpload,
      customBoldText,
    },
  } = props;

  const { enqueueSnackbar } = useSnackbar();
  const [viewOnly, setViewOnly] = useState(false);
  const [typeOfTrack, setTypeOfTrack] = useState(null);
  const [reasonForTrack, setReasonForTrack] = React.useState([]);
  const [commentNotes, SetCommentNotes] = useState('');
  const [images, setImages] = useState([]);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [openImgModal, setOpenImgModal] = useState(false);
  const [currentPDF, setCurrentPDF] = useState([]);
  const [currentImg, setCurrentImg] = useState('');
  const [imagePreview, setImagePreview] = React.useState(true);
  const [popNotice, setPopNotice] = useState('');
  const [datePicker, openDatePicker] = useState(false);
  const [id, SetId] = useState(null);
  const [dateError, setDateError] = useState(null);
  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const myRef = useRef(null);

  const currentDate = viewOnly ? null : new Date();
  // useEffect(() => {
  //   fetchTrackings();
  // }, []);

  // const fetchTrackings = async () => {
  //   try {
  //     const { data } = await fetchCTrackingDetails(note.patient.id, note.id);
  //     if (data && data.id) {
  //       openDatePicker(true);
  //       setViewOnly(!data.trackStatus || trackingEdit);
  //       setTypeOfTrack(data.typeOfTrack);
  //       setReasonForTrack(data.reasonForTrack);
  //       SetCommentNotes(data.commentNotes);
  //       SetId(data.id);
  //       setState([
  //         {
  //           startDate: new Date(data.startDate),
  //           endDate: new Date(data.endDate),
  //           key: 'selection',
  //         },
  //       ]);
  //     }
  //     if (data && data.id) {
  //       // attaching documents for upload
  //       const apiResponse = await fetchTrackAttachments(data.id);

  //       const imageObjects = makeS3BlobsRenderable(apiResponse.data);

  //       setImages(imageObjects);
  //     }
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };

  const dateChange = item => {
    setState([item.selection]);
  };

  const callSetImage = event => {
    setImages([]);
    fileSelectHandler(
      event.target.files,
      inputPicCallBack,
      ['jpg', 'jpeg', 'pdf'],
      1048576 // 1048576 bytes = 1MBl
    );
  };

  const handleOpenImg = link => {
    setOpenImgModal(true);
    setCurrentImg(link);
  };
  const handleOpenPDF = link => {
    setOpenPDFModal(true);
    setCurrentPDF(link);
  };

  const inputPicCallBack = fileObject => {
    setImages(fileObject);
    fileObject.map(fileObjectOrStatusCode => {
      if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
        const notice =
          fileObjectOrStatusCode === -1
            ? 'Max file size is 2MB'
            : 'Please use a valid file to upload';
        setPopNotice(notice);
        myRef.current.value = null;
        setImages([]);
      }
    });
  };

  const handleTypeOfTrack = event => {
    setTypeOfTrack(event.target.name);
  };
  const onSubmit = async () => {
    //debugger
    const trackingParams = {
      patientId: patientId,
      typeOfTrack,
      reasonForTrack,
      startDate: moment(state[0].startDate).format('YYYY-MM-DD'),
      endDate: moment(state[0].endDate).format('YYYY-MM-DD'),
      commentNotes,
      attachments: images.map(i => i.dataUrl),
    };
    if (trackingParams.startDate === trackingParams.endDate) {
      setPopNotice('Start Date and End Date should not be the same');
    } else {
      try {
        await trackPatient(trackingParams);
        enqueueSnackbar('Patient Tracked!', {
          preventDuplicate: true,
          autoHideDuration: 3000,
        });
      } catch {
        enqueueSnackbar('Unable to Track patient. Please try again.');
      }
      closeDialog();
    }
  };

  const onUpdate = async () => {
    const trackingParams = {
      id,
      commentNotes,
    };
    try {
      await updateTrackPatient(trackingParams);
    } catch {
      enqueueSnackbar(
        'Unable to Edit Patient Tracking Details. Please try again.'
      );
    }
    closeDialog();
  };

  const handleChange = event => {
    let index = reasonForTrack.indexOf(event.target.name);
    if (index > -1) {
      let data = reasonForTrack.filter((x, i) => i !== index);
      //  data.splice(index, 1)
      setReasonForTrack(data);
    } else {
      let value = [...reasonForTrack, event.target.name];
      setReasonForTrack(value);
    }
    // setState({ ...state, [event.target.name]: event.target.checked });
  };

  // const { gilad, jason, antoine } = state;
  // const error = [gilad, jason, antoine].filter((v) => v).length !== 2;

  const md = new MobileDetect(window.navigator.userAgent);
  const isMobile = md.mobile();
  return (
    <FullScreenDialog
      fullScreen={open}
      open={open}
      onClose={closeDialog}
      style={{ position: 'fixed', bottom: '50px' }}
    >
      <AppBar color="default" className={appBar}>
        <Toolbar>
          <Typography variant="h6" color="inherit" className={title}>
            Track New Patient{' '}
            <Typography
              variant="span"
              color="inherit"
              className={customBoldText}
            >
              {' '}
              {viewOnly ? '(Already Tracking)' : ''}
            </Typography>
          </Typography>

          <Button color="inherit" onClick={closeDialog}>
            <Close />
          </Button>
        </Toolbar>
      </AppBar>
      <div className={wholeSection}>
        <FormControl variant="filled" className={formControl}>
          <Grid className="custom-border-line" item xs={12} lg={12}>
            <label className={customLabel}> Type of tracking </label>

            <FormGroup className={customFormGroup}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={viewOnly}
                    checked={typeOfTrack === 'covid-19' ? true : false}
                    onChange={handleTypeOfTrack}
                    name="covid-19"
                  />
                }
                label="covid-19"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={viewOnly}
                    checked={
                      typeOfTrack !== 'covid-19' && typeOfTrack !== null
                        ? true
                        : false
                    }
                    onChange={handleTypeOfTrack}
                    name=""
                  />
                }
                label="others"
              />
              <div className="flexCol">
                {typeOfTrack !== 'covid-19' && typeOfTrack !== null && (
                  <TextField
                    disabled={viewOnly}
                    className={customText}
                    label="Please enter type of tracking here"
                    value={typeOfTrack}
                    variant="outlined"
                    onChange={e => setTypeOfTrack(e.target.value)}
                    id="filled-basic"
                    rows={6}
                  />
                )}
              </div>
            </FormGroup>
          </Grid>
        </FormControl>
        <form className="custom-border-line" noValidate autoComplete="off">
          <label className={customLabel}>
            {' '}
            Reason for testing (* check all that apply){' '}
          </label>
          <FormControl component="fieldset" className={formControl}>
            {/* <FormLabel className={customLabel} component="legend"> </FormLabel> */}
            <FormGroup className={customFormGroup}>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={viewOnly}
                    checked={
                      reasonForTrack.indexOf('screening') > -1 ? true : false
                    }
                    onChange={handleChange}
                    name="screening"
                  />
                }
                label="screening"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={viewOnly}
                    checked={
                      reasonForTrack.indexOf('symptoms') > -1 ? true : false
                    }
                    onChange={handleChange}
                    name="symptoms"
                  />
                }
                label="symptoms"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={viewOnly}
                    checked={
                      reasonForTrack.indexOf('exposure') > -1 ? true : false
                    }
                    onChange={handleChange}
                    name="exposure"
                  />
                }
                label="exposure "
              />
            </FormGroup>
          </FormControl>
        </form>
        <form className="custom-border-line" noValidate>
          <FormLabel className={customLabel} component="legend">
            Calendar for selecting days of Tracking
          </FormLabel>
          <Button
            className="custom-date-btn"
            color="primary"
            variant="contained"
            onClick={() => openDatePicker(!datePicker)}
          >
            select start / End date
          </Button>
          {datePicker && !viewOnly && (
            <div className={customDatePickerOne}>
              <DateRange
                minDate={new Date()}
                editableDateInputs={true}
                onChange={item => dateChange(item)}
                moveRangeOnFirstSelection={false}
                ranges={state}
              />
            </div>
          )}
          <div className="custom-date-text">
            {moment(state[0].startDate).format('MM/DD/YYYY hh:mma')} To{' '}
            {moment(state[0].endDate).format('MM/DD/YYYY hh:mma')}{' '}
          </div>
        </form>
        <form className="custom-border-line">
          <FormLabel className={customLabel} component="legend">
            Adding notes/comments
          </FormLabel>

          <TextField
            className={customTextArea}
            id="filled-multiline-static"
            multiline
            disabled={!trackingEdit && id}
            rows={6}
            variant="filled"
            value={commentNotes}
            placeholder="Add Notes here ..."
            onChange={e => SetCommentNotes(e.target.value)}
          />
        </form>

        <FormLabel component="legend" className="mt-10">
          Add attachments
        </FormLabel>
        <input
          id="fileUpload"
          hidden
          disabled={viewOnly}
          ref={myRef}
          type="file"
          multiple
          onChange={event => callSetImage(event)}
        />
        <label className={customFileUpload} for="fileUpload">
          Choose file
        </label>

        {images && images.length > 0 && isMobile ? (
          <div>{images.length} images attached</div>
        ) : (
          images.map((image, index) =>
            image?.fileType === 'pdf' ? (
              <>
                <div className="custom-m-b-space">
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={() => handleOpenPDF(image.dataUrl)}
                  >
                    Click to Preview
                  </Button>
                  <a
                    className="popup-download-btn"
                    target="_blank"
                    href={image && image.dataUrl}
                    download
                  >
                    Download
                  </a>
                </div>
                {/* <Document file={image.dataUrl} options={options} className={previewImg}>
                <Page pageNumber={1} />
              </Document> */}

                <PDFSingleViewer
                  openPDFModal={openPDFModal}
                  currentPDF={currentPDF}
                  onClose={() => setOpenPDFModal(false)}
                />
              </>
            ) : (
              <Grid container item xs={12}>
                <Grid item xs={12}>
                  <div className="custom-m-b-space">
                    <Button
                      // disabled={!imagePreview}
                      disabled={
                        image?.fileType === 'htm' || image?.fileType === 'html'
                      }
                      color="primary"
                      variant="contained"
                      onClick={() => handleOpenImg(image.dataUrl)}
                    >
                      Click to Preview
                    </Button>
                    <a
                      className="popup-download-btn"
                      target="_blank"
                      href={image && image.dataUrl}
                      download
                    >
                      Download
                    </a>
                  </div>
                </Grid>

                {/* <img src={image && image.dataUrl} key={`picture-${index}`} onError={() => setImagePreview(false)} alt="To see full report, please download the file" className={previewImg} /> */}
                <ImgSingleViewer
                  openImgModal={openImgModal}
                  currentImg={currentImg}
                  onClose={() => setOpenImgModal(false)}
                />
              </Grid>
            )
          )
        )}
        {popNotice && (
          <NoticeDialog
            open={popNotice}
            onOkClick={() => setPopNotice('')}
            noticeTitle="Notice"
            message={popNotice}
          />
        )}
        <Grid container>
          <Grid item xs={12} lg={12}>
            <div className="btnWidth">
              <Button
                className={customBtn}
                disabled={!trackingEdit && id}
                fullWidth
                color="primary"
                variant="contained"
                onClick={trackingEdit && id ? onUpdate : onSubmit}
              >
                Submit
              </Button>
            </div>
          </Grid>
        </Grid>
      </div>
    </FullScreenDialog>
  );
}

PatientCreateTrackModal.propTypes = {
  patient: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  open: PropTypes.bool,
};

const styles = () => ({
  appBar: {
    position: 'relative',
  },
  customTextArea: {
    width: '100%',
  },
  customBtn: {
    width: '15%',
    margin: '20px auto',
    display: 'block',
  },
  customBoldText: {
    fontWeight: '600',
    fontSize: '17px',
  },
  customFileUpload: {
    display: 'inline-block',
    backgroundColor: '#505d68',
    color: 'white',
    padding: '0.5rem 1rem',
    borderRadius: '0.3rem',
    cursor: 'pointer',
    marginTop: '1rem',
    marginBottom: '1rem',
  },
  customDatePickerOne: {
    position: 'relative',
  },
  customSelect: {
    width: '85%',
  },
  customFormGroup: {
    flexDirection: 'row',
    marginBottom: '15px',
    border: '1px solid #ededed',
    padding: '8px',
    paddingLeft: '25px',
  },
  wholeSection: {
    padding: '30px',
  },
  customText: {
    width: '30%',
  },
  formControl: {
    width: '100%',
  },
  customLabel: {
    fontSize: '20px',
    color: '#fff !important',
    display: 'block',
    width: '100%',
    background: '#0095da',
    padding: '11px',
    paddingLeft: '30px',
    minHeight: '49px',
  },
  title: {
    flex: 1,
    fontSize: '16px',
    lineHeight: '19px',
    color: '#1C1C1C',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
});

const fullScreenDialogStyles = theme => ({
  paperFullScreen: {
    width: '55%',
    height: '80%',
    // position: 'fixed',
    bottom: '0',
    [theme.breakpoints.down('lg')]: {
      width: '80%',
    },
  },
});

const FullScreenDialog = withStyles(fullScreenDialogStyles)(Dialog);

export default withStyles(styles)(PatientCreateTrackModal);
